export default __webpack_public_path__ + "static/blog-04-1170x600-4a8ac032ebd121ece92d791d6d0f37fa.jpg";